import { useState } from 'react'
import { useDispatch } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { setDialogEditCSVDataRow, removeCSVDataRow } from 'app/store/importCSV'
import themesConfig from 'app/fuse-configs/themesConfig'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import useStyles from './styles'

const ActionColumn = ({ index }) => {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null)
  const { formatMessage } = useIntl()
  const open = Boolean(anchorEl)
  const classes = useStyles()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const removeRow = () => {
    dispatch(removeCSVDataRow({ index }))
  }
  const handleOpenDialogEditCSVDataRow = () => {
    const payload = { open: true, index }
    dispatch(setDialogEditCSVDataRow(payload))
  }

  const options = [
    {
      label: formatMessage({ id: 'action.update' }),
      Icon: (
        <EditOutlinedIcon
          style={{ color: themesConfig.default.colors.primary }}
        />
      ),
      action: handleOpenDialogEditCSVDataRow,
      className: classes.editOption,
    },
    {
      label: formatMessage({ id: 'action.delete' }),
      Icon: (
        <DeleteOutlineIcon
          style={{ color: themesConfig.default.colors['red-600'] }}
        />
      ),
      action: removeRow,
      className: classes.deleteOption,
    },
  ]

  return (
    <div className={classes.buttonWrap}>
      <IconButton
        disableRipple
        aria-label="more"
        aria-controls="action-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={classes.button}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.actionMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
      >
        {options.map((option) => {
          const { label, Icon, className, action } = option
          return (
            <MenuItem
              key={label}
              onClick={handleClose}
              onClickCapture={action}
              className={clsx(classes.menuOption, className)}
            >
              {Icon}
              {label}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}

export default ActionColumn
